import React from 'react'
import PropTypes from 'prop-types'
import { filterCanceledUsers } from 'lib/util'
import { SiteUserTable } from './component.styles'
import {
  NAME,
  ELEMENTARY_COMPLETION,
  EXPERIENCE,
  MIDDLE_SCHOOL_COMPLETION,
  TEACHES_LESSONS,
  TOTAL_ELEM_TRAININGS,
  TOTAL_MS_TRAININGS,
} from './constants'

const SiteUserTrainingGrid = ({ className, users }) => {
  const columns = [
    {
      title: NAME,
      fieldValue: row => {
        return <b>{`${row.firstName} ${row.lastName}`}</b>
      },
      sortValue: row => row.firstName,
    },
    {
      title: TEACHES_LESSONS,
      fieldValue: row =>
        row?.flatPreferences?.teachesLessons
          ? 'Yes'
          : row?.flatPreferences?.teachesLessons === undefined
          ? 'No role set'
          : 'No',
      unbold: true,
      sortValue: row =>
        row?.flatPreferences?.teachesLessons
          ? 1
          : row?.flatPreferences?.teachesLessons === undefined
          ? 3
          : 2,
    },
    {
      title: EXPERIENCE,
      fieldValue: row => row?.flatPreferences?.experience || '-',
      unbold: true,
    },
    {
      title: ELEMENTARY_COMPLETION,
      fieldValue: row =>
        row?.flatPreferences?.teachesLessons !== undefined
          ? `${row?.trainingCompletion?.elem}/${TOTAL_ELEM_TRAININGS}`
          : '-',
      unbold: true,
    },
    {
      title: MIDDLE_SCHOOL_COMPLETION,
      fieldValue: row =>
        row?.flatPreferences?.teachesLessons !== undefined
          ? `${row?.trainingCompletion?.ms}/${TOTAL_MS_TRAININGS}`
          : '-',
      unbold: true,
    },
  ]

  return (
    <SiteUserTable
      className={className}
      columns={columns}
      filter={false}
      headThemeLight
      numOfColumns={7}
      rows={filterCanceledUsers(users)}
      sort
      defaultSort={{
        columnTitle: TEACHES_LESSONS,
        direction: 'asc',
      }}
    />
  )
}

SiteUserTrainingGrid.propTypes = {
  className: PropTypes.string,
  currentUser: PropTypes.object.isRequired,
  displayUserActions: PropTypes.bool,
  handleCancelUserAccess: PropTypes.func.isRequired,
  handleGrantNewRole: PropTypes.func.isRequired,
  handleRemindEmail: PropTypes.func.isRequired,
  hasK8License: PropTypes.boolean,
  site: PropTypes.object.isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default SiteUserTrainingGrid
